import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ProxyService } from './proxy.service';

@Injectable({
  providedIn: 'root'
})
export class ToastmessageService {
  showError(arg0: string) {
    throw new Error('Method not implemented.');
  }

  constructor(private _toasterService:ToastrService,private _proxyService:ProxyService) { }
  successDialog(message) {
    if(message) this._toasterService.success(message, '', {timeOut: 2000 });
    //this._proxyService.decrementRequestCount();
  }

  errorDialog(message) {
    if(message) this._toasterService.error(message, '', {timeOut: 2000 });
    //this._proxyService.decrementRequestCount();
  }

  warningDialog(message){
    if(message) this._toasterService.warning(message, '', {timeOut: 10000, extendedTimeOut: 1000, });
  }

  clearDialog() {
    this._toasterService.clear();
  }
}
